import { c as _c } from "react/compiler-runtime";
import { classNames, Slot } from "@opensea/ui-kit";
export function ModuleContainer(t0) {
  const $ = _c(6);
  const {
    children,
    asChild,
    className
  } = t0;
  const Comp = asChild ? Slot : "div";
  let t1;
  if ($[0] !== className) {
    t1 = classNames("[--overview-vertical-padding:32px] md:[--overview-vertical-padding:64px]", "[--gap-between-columns:64px]", "[--max-text-width:620px]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== Comp || $[3] !== children || $[4] !== t1) {
    t2 = <Comp className={t1}>{children}</Comp>;
    $[2] = Comp;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}